import "./GhostTextComponent.scss";
import template from "./GhostTextComponent.html";
import {IComponentOptions} from "angular";

export const GhostText = "tfGhostText";

export function ghostText(): IComponentOptions {
    return {
        template,
        controllerAs: "ctrl",
        controller: GhostTextComponentController
    };
}

export class GhostTextComponentController {

    /** @ngInject */
    public constructor() {

    }
}
